import React from 'react'
import Header from '../../component/Header'
import ADCA from '../ADCA'
import Footer from '../../component/Footer'

export default function LayoutADCA() {
    return (
        <div>
            <Header />
            <ADCA />
            <Footer />
        </div>
    )
}
